import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import '../../projects/src/globals.css';
import { initializeAppInsightsFromConfig } from '../../projects/src/lib/app-insights';
import { AppContainer } from './AppContainer';

// Initialize Application Insights as early as possible
initializeAppInsightsFromConfig();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root container missing in index.html');
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <AppContainer />
  </StrictMode>,
);
